import { ReferencedEntry } from 'contentful';
import noop from 'lodash/noop';
import { useCallback, useState } from 'react';

import { Navigation } from 'src/api/contentful/contentTypes.cloverdotcom';

export type NavBarContext = Readonly<{
  headerOverride?: ReferencedEntry<Navigation>;
  setHeaderOverride: (entry?: ReferencedEntry<Navigation>) => void;
  clearHeaderOverride: () => void;
  headerUtilOverride?: ReferencedEntry<Navigation>;
  setHeaderUtilOverride: (entry?: ReferencedEntry<Navigation>) => void;
  clearHeaderUtilOverride: () => void;
  hideCartIcon?: boolean;
  setHideCartIcon: (boo?: boolean) => void;
  clearHideCartIcon: () => void;
  hasSubNavBar?: boolean;
  setHasSubNavBar: (boo?: boolean) => void;
}>;

export const initialValue: NavBarContext = {
  headerOverride: undefined,
  setHeaderOverride: noop,
  clearHeaderOverride: noop,
  headerUtilOverride: undefined,
  setHeaderUtilOverride: noop,
  clearHeaderUtilOverride: noop,
  hideCartIcon: undefined,
  setHideCartIcon: noop,
  clearHideCartIcon: noop,
  hasSubNavBar: undefined,
  setHasSubNavBar: noop,
};

export const useNavBarInternal = (): NavBarContext => {
  const [ headerOverride, setHeaderOverride ] = useState<ReferencedEntry<Navigation> | undefined>();
  const clearHeaderOverride = useCallback(() => setHeaderOverride(undefined), [ setHeaderOverride ]);

  const [ headerUtilOverride, setHeaderUtilOverride ] = useState<ReferencedEntry<Navigation> | undefined>();
  const clearHeaderUtilOverride = useCallback(() => setHeaderUtilOverride(undefined), [ setHeaderUtilOverride ]);

  const [hideCartIcon, setHideCartIcon] = useState<boolean | undefined>();
  const clearHideCartIcon = useCallback(() => setHideCartIcon(undefined), [setHideCartIcon]);

  const [hasSubNavBar, setHasSubNavBar] = useState<boolean | undefined>(false);

  return {
    headerOverride,
    setHeaderOverride,
    clearHeaderOverride,
    headerUtilOverride,
    setHeaderUtilOverride,
    clearHeaderUtilOverride,
    hideCartIcon,
    setHideCartIcon,
    clearHideCartIcon,
    hasSubNavBar,
    setHasSubNavBar,
  };
};
